<template>
  <v-card
    elevation="8"
    class="driver-card"
    style="max-width: 250px; width: 100%; background-color: #f8fafd; box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.3);"
  >
    <!-- Logo -->
    <img
      src="/uspack-logo.svg"
      alt="USPack Logo"
      class="icon"
    >

    <!-- Job title (Driver) -->
    <div class="job-title">
      Driver
    </div>

    <!-- Driver Image -->
    <img
      v-if="driverCode"
      :src="driverImageUrl"
      :alt="`Driver ${driverCode}`"
      class="driver-image"
      @error="onDriverImageError"
    >

    <!-- Driver Name -->
    <h3 class="driver-name">
      {{ driverFirstName.toUpperCase() }}
    </h3>
  </v-card>
</template>


<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: "DriverBadge",
  props: {
    driverCode: {
      type: String,
      required: true
    },
    driverImageUrl: {
      type: String,
      required: true
    },
    driverFirstName: {
      type: String,
      required: true
    }
  },
  methods: {
    onDriverImageError(event: Event) {
      const target = event.target as HTMLImageElement;
      target.src =
        "data:image/svg+xml;base64," +
        btoa(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="gray"><path d="M12 12c2.7 0 5-2.3 5-5s-2.3-5-5-5-5 2.3-5 5 2.3 5 5 5zm0 2c-3.3 0-10 1.7-10 5v3h20v-3c0-3.3-6.7-5-10-5z"/></svg>`);
    }
  }
});
</script>
